export default {
    state: {
        article_logs: [],
    },
    getters: {
        latestLogTypeByArticleId: (state) => (articleId) => {
            const update_type = state.article_logs[articleId]
            if (!update_type) {
                return null
            }

            return update_type
        }
    },
    mutations: {
        setLatestLogType(state, payload) {
            const {articleId, update_type} = payload
            this._vm.$set(state.article_logs, articleId, update_type)
        },
    },
    actions: {
        async getLatestLogType(context, params) {
            const response = await this._vm.axios.get('/api/articles/log/latest-type', { params })
            const payload = {
                articleId: params.article_id,
                update_type: response.data.update_type,
            }
            context.commit('setLatestLogType', payload)
        },
        async logArticleUpdate(context, params) {
            await this._vm.axios.post(
                '/api/articles/log',
                {
                    ...params,
                }
            )
            context.commit(
                'setLatestLogType',
                {
                    articleId: params.article_id,
                    update_type: params.update_type,
                }
            )
        },
    },
}
